import { LeadGenerator_NearbyBusinessesQuery } from '@/types';

export type Business =
  LeadGenerator_NearbyBusinessesQuery['getNearbyBusinessesV2'][number];

export interface TotalSalesTableData {
  avgOrderSize: number;
  grossProfitInMicros: number | null | undefined;
  grossProfitPercentOverPeriod: number | null | undefined;
  totalOrders: number;
  totalSalesInMicros: number;
  totalSalesPercentOverPeriod: number | null | undefined;
}

export interface TotalSalesGraphData {
  totalSalesData: {
    date: string;
    totalSalesAmountInMicros: number;
  }[];
}

export interface SalesAnalyticsData
  extends TotalSalesTableData,
    TotalSalesGraphData {}

export enum TimeRange {
  L7 = 7,
  L30 = 30,
  L60 = 60,
}

export interface YelpMenuItem {
  category: string;
  ingredients: string[];
  item_name: string;
}

export interface ActivityListItem {
  metadata: {
    createdAt: string;
    employeeName: string | null;
    reminderAt: string | null;
  };
  title: string;
  value: string;
}
